import React, { Component } from 'react';
import Icon from '../../../../../icons/Icon';
import { RootState } from '../../../../../redux/store';
import { changeApiVariable, changeApiVariableAuth } from '../../../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';

class NoAuthComponent extends Component<Props> {
  render() {
    return (
      <div className={'flex flex-col w-full h-full items-center justify-center'}>
        <Icon icon={'no-folder'} size={100} />
        <div className={'px-5 py-5 bg-f-gray mt-5 rounded shadow-sm'}>This request does not user any authorization.</div>
      </div>
    );
  }
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable,
  auth: state.apiVariable.auth,
});

const mapDispatchToProps = { changeApiVariable, changeApiVariableAuth };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(NoAuthComponent);
